import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";

import { App, UnderConstruction } from "./App";
import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if ((process.env.REACT_APP_OOS as string) === "true") {
  root.render(<UnderConstruction />);
} else {
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

reportWebVitals();
